import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ScrollToTop } from "@/components/ScrollToTop";
import { SiteLayout } from "@/components/SiteLayout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import ForBusinesses from "@/pages/ForBusinesses";
import ForProfessionals from "@/pages/ForProfessionals";
import Pricing from "@/pages/Pricing";
import BookConsultation from "@/pages/BookConsultation";
import Resources from "@/pages/Resources";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminInquiries from "@/pages/admin/AdminInquiries";
import AdminIntakes from "@/pages/admin/AdminIntakes";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminPricing from "@/pages/admin/AdminPricing";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminSettings from "@/pages/admin/AdminSettings";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ivory">
        <div className="font-serif text-2xl text-espresso animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster position="top-center" toastOptions={{ style: { background: "#50322E", color: "#FAF7F2", border: "1px solid #C7A992" } }} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route element={<SiteLayout />}>
              <Route path="/about" element={<About />} />
              <Route path="/for-businesses" element={<ForBusinesses />} />
              <Route path="/for-professionals" element={<ForProfessionals />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/book" element={<BookConsultation />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/resources/:slug" element={<BlogPost />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/legal/:type" element={<Legal />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Route>

            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="inquiries" element={<AdminInquiries />} />
              <Route path="intakes" element={<AdminIntakes />} />
              <Route path="contacts" element={<AdminContacts />} />
              <Route path="newsletter" element={<AdminNewsletter />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="testimonials" element={<AdminTestimonials />} />
              <Route path="pricing" element={<AdminPricing />} />
              <Route path="payments" element={<AdminPayments />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
